export function padLeft(numero: number | string, tamanho: number) {
  numero = String(numero);
  if (numero.length < tamanho) {
    numero = `0${numero}`;
    return padLeft(numero, tamanho);
  }
  return numero;
}
